module.exports = __webpack_public_path__ + "static/media/remote-work.566c5203.png";